import { render, staticRenderFns } from "./Workspace.vue?vue&type=template&id=21ce911e&scoped=true&lang=pug&"
import script from "./Workspace.vue?vue&type=script&lang=js&"
export * from "./Workspace.vue?vue&type=script&lang=js&"
import style0 from "./Workspace.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Workspace.vue?vue&type=style&index=1&id=21ce911e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce911e",
  null
  
)

export default component.exports